// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stars{display:flex}.stars>.star{display:block;margin-right:10px;cursor:pointer}.stars>.star.-filled>.star-body{stroke:#ffb300;fill:#ffb300}.stars>.star>.star-body{stroke:#ffb300;fill:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
